
export const environment = {
  production: false,
  appUrl: 'https://tmb.exodusclinics.com',
  resourceServer: 'https://exodusiiiuatapi.azurewebsites.net',
  reportServer: 'https://exodusiiiuatreporting.azurewebsites.net',
  mytmbServer: 'https://myinfo.exodusclinics.com',
  sessionExpiredDuration: 7200, // second - time auto logout
  authConfig: {
    authority: 'https://exodusiiiuatapi.azurewebsites.net',
    redirectUri: 'https://tmb.exodusclinics.com/callback-login',
    postLogoutRedirectUri: 'https://tmb.exodusclinics.com/landing',
	silentRedirectUri: 'https://tmb.exodusclinics.com/refresh-token',
    clientId: 'ExodusIII.TmbLive',
    scope: 'openid stepone_api_accountmanagement'
  },
  versionTMB: 'Version 4.13.0 - 06 Nov 2024'
};




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/environments/environment.ts